import { render, staticRenderFns } from "./PaginationAlgolia.vue?vue&type=template&id=075d2bd9"
import script from "./PaginationAlgolia.vue?vue&type=script&lang=js"
export * from "./PaginationAlgolia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports